<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<rule-form ref="sourcebillconfigrule" :data="obj" @submit="ruleSubmit" />		
				<jindieextra ref="sourcebillconfigjindieextra" :type="type" :obj="obj" @submit="jindieSubmit" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="保存" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$select",
					"field": "billtype",
					"title": "账单类型",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"cascader":false,
						"readonly":false,
						"emptyselect":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}],
					"col": {
						"span": 24,
						"offset": 0
					}
				},
				{
					"type": "$select",
					"field": "jindietype",
					"title": "星空模块",
					"value": null,
					"hidden": false,
					"options":[{
						"value":"CN_BANKTRANSBILL",
						"label":"银行转账单"
					},{
						"value":"CN_JOURNAL",
						"label":"手工日记账"
					}],
					"props": {
						"readonly":false,
						"emptyselect":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "settlementtype",
					"title": "结算方式",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false,
						"emptyselect":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "accountplant",
					"title": "账户平台",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false,
						"emptyselect":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "mark",
					"title": "备注",
					"value": null,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import jindieextra from '../box/jindieextra'
	import ruleForm from './rule'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return {}
				}
			},
			options: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_model:false,
				modal_title: '分类',
				modal_width:1200,
				modal_height:800,
				obj:{},
				type:'',
				field:'',
				formtype:''
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 550
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'FOPPOSITEACCOUNTID',
						title: '对方科目',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_Account'], column.field, 'config_detail')
								}
							}
						},
					}, 
					// {
					// 	field: 'FOPPOSITEDETAILID__FFLEX6',
					// 	title: '核算维度(平台)',
					// 	editRender: {
					// 		name: '$inputButton',
					// 		props: {
					// 			quote: false
					// 		},
					// 		events: {
					// 			inputButtonclick: ({
					// 				row,
					// 				column
					// 			}) => {
					// 				this.jindieBoxShow(row, ['BD_Customer'], column.field, 'config_detail')
					// 			}
					// 		}
					// 	},
					// }, 
					// {
					// 	field: 'FOPPOSITEDETAILID__FFLEX5',
					// 	title: '核算维度(部门)',
					// 	editRender: {
					// 		name: '$inputButton',
					// 		props: {
					// 			quote: false
					// 		},
					// 		events: {
					// 			inputButtonclick: ({
					// 				row,
					// 				column
					// 			}) => {
					// 				this.jindieBoxShow(row, ['BD_Department'], column.field, 'config_detail')
					// 			}
					// 		}
					// 	},			
					// }, 
					{
						field: 'FOPPOSITEDETAILID__FFLEX9',
						title: '核算维度(费用项目)',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick: ({
									row,
									column
								}) => {
									this.jindieBoxShow(row, ['BD_Expense'], column.field, 'config_detail')
								}
							}
						},			
					}, {
						field: 'abstract',
						title: '摘要',
						editRender: {
							name: '$input',
							props: {
								quote: false
							},
							events: {}
						},		
						visible:false
					}, {
						field: 'rule',
						title: '规则',
					
					}, {
						field: 'outplant',
						title: '转出平台',
						editRender: {
							name: '$select',
							props: {
								selectoptions:[{
									value:'zhifubao',
									label:'支付宝'
								},{
									value:'yulibao',
									label:'余利宝'
								},{
									value:'wangshang',
									label:'网商银行'
								}],
								quote: false
							},
							events: {}
						},	
					
					}, {
						field: 'inplant',
						title: '转入平台',
						editRender: {
							name: '$select',
							props: {
								selectoptions:[{
									value:'zhifubao',
									label:'支付宝'
								},{
									value:'yulibao',
									label:'余利宝'
								},{
									value:'wangshang',
									label:'网商银行'
								}],
								quote: false
							},
							events: {}
						},	
					},{
						field: 'rulejson',
						title: '规则JSON',
						visible:false
					}, {
						field: 'FOPPOSITEACCOUNTID_CODE',
						title: '对方科目_编码',
						visible:false
					}, 
					// {
					// 	field: 'FOPPOSITEDETAILID__FFLEX6_CODE',
					// 	title: '核算维度(平台)_编码',
					// 	visible:false
					// }, 
					// {
					// 	field: 'FOPPOSITEDETAILID__FFLEX5_CODE',
					// 	title: '核算维度(部门)_编码',
					// 	visible:false
					// }, 
					{
						field: 'FOPPOSITEDETAILID__FFLEX9_CODE',
						title: '核算维度(费用项目)_编码',
						visible:false
					},					
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.rule(row)}}>规则</el-button>,
									<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					rule: [{
						required: true
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.data.detail ? this.data.detail : []
					})
				})
			},
			modal_init(){
				this.sourceData = this.data
				let formData = JSON.parse(JSON.stringify(formjson))
				
				
				let rule = formData.rule.rule
				rule.forEach((item)=>{
					if(item.field == 'settlementtype'){
						item.options = this.options.settlementtype??[]
					}
					if(item.field == 'accountplant'){
						item.options = this.options.accountplant??[]
					}
				})
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()	
					this.$api.sourcebill.getconfig().then((res)=>{
						let billtype = this.fApi.el('billtype')
						billtype.options =  res.map((item)=>{
							return {
								value:item,
								label:item
							}
						})
					})	
				})
				this.$emit('show')				
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						if(item == 'jindietype'){
							if(this.sourceData[item]){
								this.fApi.setValue(item, this.sourceData[item])
								this.jindietypeChange(this.sourceData[item])
							}else{
								this.fApi.setValue('jindietype', 'CN_JOURNAL')
								this.jindietypeChange('CN_JOURNAL')
							}
						}else{
							this.fApi.setValue(item, this.sourceData[item])
						}
						
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			rule(row){
				this.obj = row
				this.$nextTick(()=>{
					this.$refs.sourcebillconfigrule.modal_show()
				})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			jindietypeChange(e){
				let column = this.getgrid().getTableColumn().fullColumn
				let showcolumn = []
				if (e == 'CN_BANKTRANSBILL') {
					this.fApi.updateRule('settlementtype', {
						hidden: true,
						validate: {
							required: false,
							message: "必填项"
						}
					})
					this.fApi.updateRule('accountplant', {
						hidden: true,
						validate: {
							required: false,
							message: "必填项"
						}
					})
					showcolumn = ['abstract', 'inplant', 'outplant', 'rule']
				}
				if (e == 'CN_JOURNAL') {
					this.fApi.updateRule('settlementtype', {
						hidden: false,
						validate: {
							required: true,
							message: "必填项"
						}
					})
					this.fApi.updateRule('accountplant', {
						hidden: false,
						validate: {
							required: true,
							message: "必填项"
						}
					})
					showcolumn = ['FOPPOSITEACCOUNTID', 'FOPPOSITEDETAILID__FFLEX9', 'abstract', 'rule']
				}
				column.forEach((item)=>{
					let target = showcolumn.find((_item)=>{
						return _item  == item.field
					})
					if(item.field && target){
						item.visible = true
					}else{
						item.visible = false
					}
					if(!item.field){
						item.visible = true
					}
				})
				this.getgrid().refreshColumn()
			},
			ruleSubmit(e){
				//console.log(e.data)
				let rule = []
				e.data.forEach((item,index)=>{
					let str = ''
					if(index == 0){
						str = '【'+item.field+'】' + item.symbol + '【'+(item.value ? item.value : '空')+'】'
					}else{
						str = (item.logic?item.logic:'且') + '【'+item.field+'】' + item.symbol + '【'+(item.value ? item.value : '空')+'】'
					}
					rule.push(str)
				})
				
				this.obj.rulejson = e.data
				this.obj.rule = rule.join('')
				console.log(this.obj.rule)
				
			},
			submit() {
				this.fApi.submit((formData) => {
		
					//console.log(submitData)
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							let detail = this.getgrid().getTableData().visibleData
							detail = JSON.parse(JSON.stringify(detail))
							detail.forEach((item)=>{
								delete(item._X_ROW_CHILD)
								delete(item._X_ROW_KEY)
							})
							submitData.detail = detail
							this.loading = true
							if(this.data.id){
								this.$api.sourcebill.update(this.data.id,submitData).then(()=>{
									this.$emit('submit')
									this.modal_cancel()
									this.loading = false
								},()=>{
									this.loading = false
								})
							}else{
								this.$api.sourcebill.save(submitData).then(()=>{
									this.$emit('submit')
									this.modal_cancel()
									this.loading = false
								},()=>{
									this.loading = false
								})
							}
							//console.log(submitData)
						} else {
							for (let i in res) {
								console.log(res[i][0].rule)
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			},
			jindieBoxShow(obj, type, field, formtype) {
				this.obj = obj
				this.type = type
				this.field = field
				this.formtype = formtype
				this.$refs.sourcebillconfigjindieextra.initList()
				this.$refs.sourcebillconfigjindieextra.box.alertBox()
			},
			jindieSubmit(e) {
				this.obj[this.field] = e.data.FName
				this.obj[this.field + '_CODE'] = e.data.FNumber
				console.log(e)
			},
		},
		components: {
			jindieextra,
			ruleForm
		}
	}
</script>